import TextFormatter from 'utils/TextFormatter';

export default(outletsToSqc, sqcDetails, currentValidation) => {

    const sqcOutcomelist = [];
    let needsMtOrder = false;
    let customerImpacting = false;
    let totalFailCount = 0;

    outletsToSqc.forEach((outlet) => {
        let macAddress = TextFormatter.formatMacAddress(outlet.get('macAddress'));

        if (macAddress) {
            macAddress = macAddress.toLowerCase();
        }

        const foundSqc = sqcDetails.getIn([macAddress]);

        if (!foundSqc) {
            return {
                currentValidation: currentValidation.setIn([
                    'sqc', 'isValid'
                ], false).setIn([
                    'sqc', 'message'
                ], 'No modem levels were found.')
            };
        }

        const downStreamPowerPassing = foundSqc.getIn([
            'data',
            'certificate',
            'rf',
            'downstream',
            'power',
            'score'
        ]) === 'Pass';

        const downStreamSnrPassing = foundSqc.getIn([
            'data',
            'certificate',
            'rf',
            'downstream',
            'snr',
            'score'
        ]) === 'Pass';

        const upStreamPowerPassing = foundSqc.getIn([
            'data',
            'certificate',
            'rf',
            'upstream',
            'power',
            'score'
        ]) === 'Pass';

        const upStreamSnrPassing = foundSqc.getIn([
            'data',
            'certificate',
            'rf',
            'upstream',
            'snr',
            'score'
        ]) === 'Pass';

        // 4 of 4 Auto Same Day 3 of 4 was option Same or next 2 of 4 was option Next
        // day or Escalate 1 of 4 was same as 2 of 4  Option for Next day or Escalate

        let failCount = 0;

        if (!downStreamPowerPassing) {
            failCount = failCount += 1;
        }

        if (!downStreamSnrPassing) {
            failCount = failCount += 1;
        }

        if (!upStreamSnrPassing) {
            failCount = failCount += 1;
        }

        if (!upStreamPowerPassing) {
            failCount = failCount += 1;
        }

        if (failCount === 4) {
            needsMtOrder = true;
            customerImpacting = true;
        }

        if (failCount === 3) {
            needsMtOrder = true;
            customerImpacting = false;
        }

        if (failCount === 2) {
            needsMtOrder = true;
            customerImpacting = false;
        }

        if (failCount === 1) {
            needsMtOrder = false;
            customerImpacting = false;
        }        
        totalFailCount += failCount;
        sqcOutcomelist.push({downStreamPowerPassing, downStreamSnrPassing, upStreamPowerPassing, upStreamSnrPassing, failCount});

    });

    return {needsMtOrder, customerImpacting, sqcOutcomelist, totalFailCount};

};


// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/outletSqcCheck.js